import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const parentRoute = { component: { render: h => h('router-view') } }

var routes = [
  // Core app pages
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/CoreApp.vue'),
    meta: { requireAuth: true },
    children: [
      {
        path: 'dashboard',
        ...parentRoute,
        props: true,
        meta: { breadcrumb: 'Dashboard', breadcrumbName: 'dashboard' },
        children: [
          {
            path: '',
            name: 'dashboard',
            component: () => import('@/views/Dashboard.vue'),
            props: true,
            meta: { mobileCompatible: true }
          }
        ]
      },
      // Microsites Duplicate of projects
      {
        path: 'microsites',
        ...parentRoute,
        props: true,
        meta: { breadcrumb: 'microsites', breadcrumbName: 'microsites' },
        children: [
          {
            path: '',
            name: 'microsites',
            component: () => import('@/views/Microsites.vue'),
            props: true,
            meta: { mobileCompatible: true }
          },
          {
            path: ':testId',
            props: true,
            ...parentRoute,
            children: [
              {
                path: 'report',
                props: true,
                ...parentRoute,
                meta: { breadcrumb: 'Report', breadcrumbName: 'testReport', mobileCompatible: true },
                children: [
                  {
                    path: '',
                    name: 'testReport',
                    component: () => import('@/views/TestReport.vue'),
                    props: true,
                    meta: { mobileCompatible: true }
                  },
                  {
                    path: 'sessions',
                    name: 'sessionData',
                    component: () => import('@/views/SessionData.vue'),
                    props: true,
                    meta: { breadcrumb: 'Sessions', mobileCompatible: true }
                  }
                ]
              }
            ]
          }
        ]
      },
      // Microsites Duplicate of projects End
      {
        path: '/all-qr-codes',
        name: 'all-qr-codes',
        component: () => import('@/views/AllQrCodes.vue'),
        meta: {
          requireAdmin: true,
          breadcrumb: 'All Qr Codes'
        }
      },
      {
        path: '/admin-qr-code',
        ...parentRoute,
        meta: { requireAdmin: true, breadcrumb: 'All QR Codes', breadcrumbName: 'all-qr-codes' },
        children: [
          {
            path: ':codeId/report',
            name: 'qr-code-report-admin',
            props: true,
            component: () => import('@/components/QRCodeStudio/QRCodeReportPage.vue'),
            meta: { requireAdmin: true, breadcrumb: 'Report', mobileCompatible: true }
          }
        ]
      },
      {
        path: '/published-tests',
        ...parentRoute,
        meta: { requireAdmin: true, breadcrumb: 'Published Projects', breadcrumbName: 'publishedTests' },
        children: [
          {
            path: '',
            ...parentRoute,
            name: 'publishedTests',
            component: () => import('@/views/PublishedTests.vue'),
            meta: { requireAdmin: true }
          },
          {
            path: 'view/:testId',
            name: 'adminViewTest',
            component: () => import('@/views/AdminTestSummary.vue'),
            props: true,
            meta: { breadcrumb: 'Details' }
          },
          {
            path: 'report/:testId',
            name: 'adminViewReport',
            component: () => import('@/views/TestReport.vue'),
            props: true,
            meta: { breadcrumb: 'Report' }
          }
        ]
      },
      {
        path: '/manage-users',
        ...parentRoute,
        meta: { requireAdmin: true, breadcrumb: 'Manage Users', breadcrumbName: 'manageUsers' },
        children: [
          {
            path: '',
            name: 'manageUsers',
            component: () => import('@/views/ManageUsers.vue')
          },
          {
            path: 'user/:userId',
            ...parentRoute,
            props: true,
            meta: {
              breadcrumb: (route) => {
                if (route.params.userId) {
                  if (store.getters['admin/users'] && store.getters['admin/users'][route.params.userId]) {
                    const user = store.getters['admin/users'][route.params.userId]
                    return user.name || user.username
                  }
                }
                return route.params.userId
              }
            },
            children: [
              {
                path: '',
                props: true,
                name: 'manageUser',
                component: () => import('@/views/ManageUserDetail.vue')
              },
              {
                path: 'view/:testId',
                name: 'viewUserTest',
                component: () => import('@/views/AdminTestSummary.vue'),
                props: true,
                meta: { breadcrumb: 'Project Details' }
              },
              {
                path: 'report/:testId',
                name: 'viewUserReport',
                component: () => import('@/views/TestReport.vue'),
                props: true,
                meta: { breadcrumb: 'Project Report' }
              }
            ]
          }
        ]
      },
      {
        path: '/manage-enterprise',
        ...parentRoute,
        meta: { requireAdmin: true, breadcrumb: 'Manage Enterprise Accounts', breadcrumbName: 'manageEnterprise' },
        children: [
          {
            path: '',
            name: 'manageEnterprise',
            component: () => import('@/views/ManageEnterpriseAccounts.vue')
          },
          {
            path: 'account/:accountId',
            ...parentRoute,
            props: true,
            meta: {
              breadcrumb: (route) => {
                if (route.params.accountId) {
                  if (store.getters['admin/enterpriseAccounts'] && store.getters['admin/enterpriseAccounts'][route.params.accountId]) {
                    const account = store.getters['admin/enterpriseAccounts'][route.params.accountId]
                    return account.name
                  }
                }
                return route.params.accountId
              },
              breadcrumbName: 'manageEnterprise'
            },
            children: [
              {
                path: 'edit',
                props: true,
                name: 'editEnterpriseAccount',
                component: () => import('@/views/ManageEnterpriseAccount.vue'),
                meta: { breadcrumb: 'Edit Settings' }
              },
              {
                path: 'view',
                props: true,
                name: 'viewEnterpriseAccount',
                component: () => import('@/views/EnterpriseAccount.vue'),
                meta: { breadcrumb: 'View Account' }
              }
            ]
          },
          {
            path: 'new-account',
            name: 'newEnterpriseAccount',
            component: () => import('@/views/ManageEnterpriseAccount.vue'),
            meta: { breadcrumb: 'New Account' }
          }
        ]
      },
      {
        path: '/manage-plans',
        name: 'managePlans',
        component: () => import('@/views/ManagePlans.vue'),
        meta: { requireAdmin: true, breadcrumb: 'Manage Plans', breadcrumbName: 'managePlans' }
      },
      {
        path: '/stats',
        name: 'highLevelStats',
        component: () => import('@/views/Stats.vue'),
        meta: { requireAdmin: true, breadcrumb: 'Stats', breadcrumbName: 'stats' },
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('@/views/EnterpriseAccount.vue'),
        meta: { requireAdmin: false, breadcrumb: 'Business Account', mobileCompatible: true }
      },
      {
        path: '/customers',
        name: 'customers',
        component: () => import('@/views/Customers.vue'),
        meta: { requireAdmin: false, breadcrumb: 'Customers', mobileCompatible: true }
      },
      {
        path: '/qr-studio',
        name: 'qr-studio',
        component: () => import('@/views/QrStudio.vue'),
        meta: { requireAdmin: false, breadcrumb: 'QR Studio', mobileCompatible: true }
      },
      {
        path: '/qr-code-alt',
        name: 'qr-code-new-alt',
        component: () => import('@/components/QRCodeStudio/QRCodeBuilder_Alternative.vue'),
        meta: { requireAdmin: false, breadcrumb: 'New QR', mobileCompatible: true }
      },
      {
        path: '/qr-code',
        ...parentRoute,
        meta: { requireAdmin: false, breadcrumb: 'QR Studio', breadcrumbName: 'qr-studio' },
        children: [
          {
            path: '',
            name: 'qr-code-new',
            props: true,
            component: () => import('@/components/QRCodeStudio/QRCodePage.vue'),
            meta: { requireAdmin: false, breadcrumb: 'New QR', mobileCompatible: true }
          },
          {
            path: ':codeId',
            name: 'qr-code-editing',
            props: true,
            component: () => import('@/components/QRCodeStudio/QRCodePage.vue'),
            meta: { requireAdmin: false, breadcrumb: 'Edit QR', mobileCompatible: true }
          },
          {
            path: ':codeId/report',
            name: 'qr-code-report',
            props: true,
            component: () => import('@/components/QRCodeStudio/QRCodeReportPage.vue'),
            meta: { requireAdmin: false, breadcrumb: 'Report', mobileCompatible: true }
          }
        ]
      },
      {
        path: '/domains',
        name: 'domains',
        component: () => import('@/views/Domains.vue'),
        meta: { requireAdmin: false, breadcrumb: 'Custom Domains', mobileCompatible: true }
      },
      {
        path: '/custom-fonts',
        name: 'custom-fonts',
        component: () => import('@/views/CustomFonts.vue'),
        meta: { requireAdmin: false, breadcrumb: 'Custom Fonts', mobileCompatible: true }
      },
      {
        path: '/plan',
        ...parentRoute,
        meta: { breadcrumb: 'Plan', breadcrumbName: 'plan' },
        children: [
          {
            path: '',
            name: 'plan',
            component: () => import('@/views/Plans.vue'),
            meta: { mobileCompatible: true }
          }
        ]
      },
      {
        path: '/assets',
        name: 'assets',
        component: () => import('@/views/Assets.vue'),
        meta: { breadcrumb: 'Assets', mobileCompatible: true }
      },
      {
        path: '/builder',
        ...parentRoute,
        meta: { requireAdmin: false, breadcrumb: 'Microsites', breadcrumbName: 'microsites' },
        children: [
          {
            path: '',
            name: 'builderNew',
            component: () => import('@/views/Builder.vue'),
            meta: { requireAdmin: false, breadcrumb: 'New Flow', mobileCompatible: true }
          },
          {
            path: ':testId',
            name: 'builder',
            props: true,
            component: () => import('@/views/Builder.vue'),
            meta: { requireAdmin: false, breadcrumb: 'Edit', mobileCompatible: true }
          }
        ]
      },
      {
        path: '/templates',
        name: 'manageTemplates',
        component: () => import('@/views/Templates.vue'),
        meta: { requireAdmin: true, breadcrumb: 'Manage Templates' }
      },
      {
        path: '/placements',
        name: 'placements',
        component: () => import('@/views/Placements.vue'),
        meta: { requireAdmin: true, breadcrumb: 'Placements', mobileCompatible: true }
      },
      {
        path: '/integrations',
        name: 'integrations',
        component: () => import('@/views/Integrations.vue'),
        meta: { requireAdmin: true, breadcrumb: 'Integrations', mobileCompatible: true }
      },
      {
        path: '/mailchimp/install',
        name: 'installMailchimp',
        props: { service: 'mailchimp' },
        component: () => import('@/views/InstallIntegration.vue'),
        meta: { mobileCompatible: true }
      },
      {
        path: '/install/:service',
        name: 'installIntegration',
        props: true,
        component: () => import('@/views/InstallIntegration.vue'),
        meta: { mobileCompatible: true }
      },
      {
        path: '/authorize/:app',
        name: 'authorize',
        props: true,
        component: () => import('@/views/Authorize.vue'),
        meta: { mobileCompatible: true }
      }
    ]
  },
  // Shopify authentication pages
  // {
  //   path: '/shopify',
  //   name: 'shopify',
  //   component: () => import('@/views/Shopify'),
  //   meta: { hideNav: true, mobileCompatible: true },
  //   children: [
  //     {
  //       path: 'auth',
  //       name: 'shopifyInstall',
  //       component: () => import('@/views/ShopifyInstall'),
  //       meta: { hideNav: true, mobileCompatible: true }
  //     },
  //     {
  //       path: 'reauth/callback',
  //       props: { force: true },
  //       name: 'shopifyCallbackReAuth',
  //       component: () => import('@/views/ShopifyCallback'),
  //       meta: { hideNav: true, mobileCompatible: true }
  //     },
  //     {
  //       path: 'auth/callback',
  //       name: 'shopifyCallback',
  //       component: () => import('@/views/ShopifyCallback'),
  //       meta: { hideNav: true, mobileCompatible: true }
  //     },
  //     {
  //       path: 'auth/link',
  //       name: 'shopifyLink',
  //       component: () => import('@/views/ShopifyLink'),
  //       meta: { hideNav: true, mobileCompatible: true }
  //     },
  //     {
  //       path: 'subscribe',
  //       name: 'shopifySubscribe',
  //       props: true,
  //       component: () => import('@/views/ShopifySubscribe'),
  //       meta: { hideNav: true, mobileCompatible: true }
  //     }
  //   ]
  // },

  // Authentication-related pages
  {
    path: '/auth',
    component: () => import('@/views/AppAuth.vue'),
    meta: { isAuthPage: true },
    children: [

      {
        path: '/sign-in',
        name: 'signin',
        props: true,
        component: () => import('@/views/AuthOptions.vue')
      },
      {
        path: '/sign-in-with-email',
        name: 'signin-with-email',
        props: true,
        component: () => import('@/views/Signin.vue')
      },
      {
        path: '/join',
        name: 'join',
        component: () => import('@/views/Join.vue')
      },
      {
        path: '/account-confirmation',
        name: 'accountConfirmation',
        component: () => import('@/views/AccountConfirmation.vue')
      },
      {
        path: '/verify',
        name: 'verify',
        component: () => import('@/views/Verify.vue')
      },
      {
        path: '/forgot-password',
        name: 'forgotPassword',
        component: () => import('@/views/ForgotPassword.vue')
      },
      {
        path: '/reset-password',
        name: 'resetPassword',
        component: () => import('@/views/ResetPassword.vue')
      },
      {
        path: 'setup-mfa',
        name: 'setupMfa',
        component: () => import('@/views/SetupMfa.vue')
      },
      {
        path: 'verify-mfa',
        name: 'verifyMfa',
        component: () => import('@/views/VerifyMfa.vue')
      }
    ]
  },

  // Experience landing pages
  // {
  //   path: '/projects/:testId/landing',
  //   name: 'testLandingPage',
  //   props: true,
  //   component: () => import('@/views/TestLandingPage.vue')
  // },
  // {
  //   path: '/projects/:testId/landing/:variant',
  //   name: 'variantTestLandingPage',
  //   props: true,
  //   component: () => import('@/views/TestLandingPage.vue')
  // },
  {
    path: '/subscribed',
    name: 'testSubscribedPage',
    component: () => import('@/views/TestSubscribedPage.vue')
  },
  {
    path: '*',
    name: 'Not found',
    component: () => import('@/views/404.vue')
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
  const authUser = store.getters['auth/authUser']

  if (to.name.startsWith('shopify')) store.commit('auth/setSource', 'shopify')

  if (to.query && to.query.mode === 'verifyEmail' && to.name !== 'verify') {
    next({ name: 'verify', query: { mode: to.query.mode, oobCode: to.query.oobCode } })
  } else if (to.query && to.query.mode === 'resetPassword' && to.name !== 'resetPassword') {
    next({ name: 'resetPassword', query: { mode: to.query.mode, oobCode: to.query.oobCode } })
  } else if (authUser !== false) {
    if (authUser && !authUser.emailVerified) {
      console.log('router.beforeEach: email not verified, redirecting to accountConfirmation')
      if (!(to.name === 'accountConfirmation' || to.name === 'verify')) next({ name: 'accountConfirmation' })
      else next()
    } else if (store.getters['shopify/hasUnpaidStore'] &&
      !to.name.startsWith('shopify')
    ) {
      next({ name: 'shopifySubscribe' })
    } else if (to.name === 'home') {
      if (authUser) {
        next({ name: 'dashboard' })
      } else next({ name: 'signin', params: { nextPage: { name: 'dashboard' } } })
    } else if (store.getters.isPendingUpdate) {
      window.location = to.fullPath
    } else next()
  } else {
    if (to.matched.some(route => route.meta.requireAuth)) {
      next({ name: 'signin', params: { nextPage: to } })
    } else if (to.name === 'home' && typeof to.query.mode === 'undefined') {
      next('/sign-in')
    } else next()
  }
})

export default router
